import endpoints from "../models/api/api.endpoints";
import api from "../helpers/api.service";
import Helper from "../helpers/helper.service";
import ServiceResponseCode from "../models/service.response.code";
import uploadService from "../helpers/upload.service";
import modoAlunoService from "./ModoAluno.service";

export default {
  async caixaEntrada(
  page = null,
  pageSize = null,
  pesquisa = null,
  modo = null,
  idMensagemSel = null,
  somenteNaoVisualizadas = false) {
    try {
      const params = [
        {
          Name: 'page',
          Value: page
        },
        {
          Name: 'pageSize',
          Value: pageSize
        },
        {
          Name: 'pesquisa',
          Value: pesquisa
        },
        {
          Name: 'modo',
          Value: modo
        },
        {
          Name: 'modoAluno',
          Value: modoAlunoService.getIdModoAluno(),
        },
        {
          Name: 'idMensagemSel',
          Value: idMensagemSel,
        },
        {
          Name: 'somenteNaoVisualizadas',
          Value: somenteNaoVisualizadas ? 1 : null,
        },
      ]
      const url = `${endpoints.mensagem}/caixa-entrada${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async listaCursos(
  idPeriodoLetivo = null,
  idFranqueadoUnidade = null
  ) {

    const params = [
      {
        Name: 'idPeriodoLetivo',
        Value: idPeriodoLetivo,
      },
      {
        Name: 'idFranqueadoUnidade',
        Value: idFranqueadoUnidade,
      },
      {
        Name: 'modoAluno',
        Value: modoAlunoService.getIdModoAluno(),
      },
    ]
    try {
      const url = `${endpoints.mensagem}/lista-cursos${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async listaDisciplinas(
  pageSize = null,
  pesquisa = null,
  idCurso = null,
  listaCursos = null,
  idPeriodoLetivo = null,
  idFranqueadoUnidade = null
  ) {

    const params = [
      {
        Name: 'modoAluno',
        Value: modoAlunoService.getIdModoAluno(),
      },
      {
        Name: 'pageSize',
        Value: pageSize
      },
      {
        Name: 'pesquisa',
        Value: pesquisa
      },
      {
        Name: 'idCurso',
        Value: idCurso
      },
      {
        Name: 'listaCursos',
        Value: listaCursos
      },
      {
        Name: 'idPeriodoLetivo',
        Value: idPeriodoLetivo
      },
      {
        Name: 'idFranqueadoUnidade',
        Value: idFranqueadoUnidade
      },
    ]

    try {
      const url = `${endpoints.mensagem}/lista-disciplinas${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async listaUsuarios(
  page = null,
  pageSize = null,
  pesquisa = null,
  idCurso = null,
  idDisciplina = null,
  selMultDisciplinas = null,
  tipoEnvioMensagem = null,
  idFranqueadoUnidade = null) {
    const params = [
      {
        Name: 'modoAluno',
        Value: modoAlunoService.getIdModoAluno(),
      },
      {
        Name: 'page',
        Value: page
      },
      {
        Name: 'pageSize',
        Value: pageSize
      },
      {
        Name: 'pesquisa',
        Value: pesquisa
      },
      {
        Name: 'idCurso',
        Value: idCurso
      },
      {
        Name: 'idDisciplina',
        Value: idDisciplina
      },
      {
        Name: 'selMultDisciplinas',
        Value: selMultDisciplinas
      },
      {
        Name: 'tipoEnvioMensagem',
        Value: tipoEnvioMensagem
      },
      {
        Name: 'idFranqueadoUnidade',
        Value: idFranqueadoUnidade
      },
    ]
    try {
      const url = `${endpoints.mensagem}/lista-usuarios${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getMensagem(idMensagem = null) {
    const params = [
      {
        Name: 'modoAluno',
        Value: modoAlunoService.getIdModoAluno(),
      },
      {
        Name: 'idMensagem',
        Value: idMensagem
      },
    ]
    try {
      const url = `${endpoints.mensagem}/mensagem${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getMensagemUsuario(idMensagemUsuario = null) {
    const params = [
      {
        Name: 'modoAluno',
        Value: modoAlunoService.getIdModoAluno(),
      },
      {
        Name: 'idMensagemUsuario',
        Value: idMensagemUsuario
      },
    ]
    try {
      const url = `${endpoints.mensagem}/mensagem-usuario${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async updateMensagens(data, tipo) {
    try {
      const url = `${endpoints.mensagem}/update/${tipo}`;
      const result = await api.post(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async listaAnexosUsuario() {
    try {
      const url = `${endpoints.mensagem}/lista-anexos-usuario`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async removerAnexo(dados) {
    try {
      const url = `${endpoints.mensagem}/remover-anexo`;
      const result = await api.post(url, dados)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async registerMensagem(data) {
    try {

      if (modoAlunoService.getIdModoAluno())
        throw new Error('Impossível realizar esta ação no Modo Aluno|warning')

      const url = `${endpoints.mensagem}/enviar`;
      const result = await api.post(url, data, undefined, 3600)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getNotificacaoNaoLidas() {

    const params = [
      {
        Name: 'modoAluno',
        Value: modoAlunoService.getIdModoAluno(),
      },
    ]
    try {
      const url = `${endpoints.mensagem}/minhas-notificacoes${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async gravarToken(data) {
    try {
      const url = `${endpoints.mensagem}/update-token`;
      const result = await api.post(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getNotificacoesUsuario(
    page = null,
    pageSize = null,
    modo = null,
    somenteNaoVisualizadas = false) {
    try {
      const params = [
        {
          Name: 'page',
          Value: page
        },
        {
          Name: 'pageSize',
          Value: pageSize
        },
        {
          Name: 'modo',
          Value: modo
        },
        {
          Name: 'somenteNaoVisualizadas',
          Value: somenteNaoVisualizadas ? 1 : null,
        },
      ]
      const url = `${endpoints.mensagem}/notificacoes-usuario${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async updateNotificacao(data) {
    try {
      const url = `${endpoints.mensagem}/update-notificacao`;
      const result = await api.post(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
}
